export default {
  reset(context) {
    context.commit("setComments", []);
    context.commit("setCount", 0);
  },
  getAll(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/community?show_parents=false&${queryString}`)
        .then(response => {
          context.commit("addComments", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },
  getTopComments(context) {
    if (context.state.topComments.length) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/community?show_parents=false&limit=3&ordering=-count`)
        .then(response => {
          context.commit("setTopComments", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getTopLikes(context) {
    if (context.state.topLikes.length) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/community?show_parents=false&limit=3&ordering=-like`)
        .then(response => {
          context.commit("setTopLikes", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getUserTopics(context, userId) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/community?show_parents=false&limit=99&user_id=${userId}&ordering=-created_at`
        )
        .then(response => {
          context.commit("setUserTopics", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getUsers(context, params) {
    const query = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/accounts/search-profile?${query}`)
        .then(response => {
          context.commit("setUsers", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  get(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/community/${id}`)
        .then(response => {
          context.commit("setComment", response.data);
          resolve();
        })
        .catch(reject);
    });
  },
  add(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/community", data)
        .then(resolve)
        .catch(reject);
    });
  },
  interact(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/community/interaction", data)
        .then(resolve)
        .catch(reject);
    });
  },
  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/community/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  remove(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/community/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
